"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _ahooks = require("ahooks");

var _reactResponsive = require("react-responsive");

var _constants = require("../../../../constants/constants");

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _Elements = require("../../../../Elements");

var _helpers = require("../../../../../../lib/helpers");

var _Elements2 = require("./Elements");

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var NewtonFolder = function NewtonFolder(_ref) {
  var folders = _ref.folders,
      publicUrl = _ref.publicUrl,
      colour = _ref.colour,
      webpSupported = _ref.webpSupported;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderBoxHeight = _useState2[0],
      setSliderBoxHeight = _useState2[1];

  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var sliderBoxRef = (0, _react.useRef)(null);
  var scrollBoxRef = (0, _react.useRef)(null);

  var _useThrottleFn = (0, _ahooks.useThrottleFn)(function (e) {
    var _scrollBoxRef$current, _scrollBoxRef$current2;

    var offset = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY; // eslint-disable-next-line no-unused-expressions

    // eslint-disable-next-line no-unused-expressions
    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current = scrollBoxRef.current) === null || _scrollBoxRef$current === void 0 ? void 0 : _scrollBoxRef$current.scrollTo((scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current2 = scrollBoxRef.current) === null || _scrollBoxRef$current2 === void 0 ? void 0 : _scrollBoxRef$current2.scrollLeft) + offset * 40, 0);
  }, {
    wait: 100
  }),
      run = _useThrottleFn.run; // eslint-disable-next-line consistent-return


  var handleScroll = function handleScroll(e) {
    e.preventDefault();
    run(e);
  };

  (0, _react.useEffect)(function () {
    var _sliderBoxRef$current, _scrollBoxRef$current3;

    if (sliderBoxRef !== null && sliderBoxRef !== void 0 && (_sliderBoxRef$current = sliderBoxRef.current) !== null && _sliderBoxRef$current !== void 0 && _sliderBoxRef$current.clientHeight) {
      // 76 is theme topnav height
      setSliderBoxHeight(window.innerHeight - 76);
    } // Safari: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#browser_compatibility
    // eslint-disable-next-line no-unused-expressions


    var passiveSupported = (0, _helpers.checkEventListenerOptionsObjectSupport)();
    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current3 = scrollBoxRef.current) === null || _scrollBoxRef$current3 === void 0 ? void 0 : _scrollBoxRef$current3.addEventListener('wheel', handleScroll, passiveSupported ? {
      passive: true
    } : false);
    return function () {
      var _scrollBoxRef$current4;

      return scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current4 = scrollBoxRef.current) === null || _scrollBoxRef$current4 === void 0 ? void 0 : _scrollBoxRef$current4.removeEventListener('wheel', handleScroll);
    };
  }, []);
  var slideHeight = sliderBoxHeight - 68 - 80 - 56;

  if (isTabletPortrait) {
    return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledSliderBox, {
      ref: sliderBoxRef,
      isDesktopSmall: isDesktopSmall
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.ScrollBox, {
      ref: scrollBoxRef,
      isDesktopSmall: isDesktopSmall
    }, folders.map(function (folder) {
      if (folder) {
        var _folder$coverPhoto, _folder$coverPhoto2, _folder$coverPhoto5;

        var imgStyle = {};

        if (((_folder$coverPhoto = folder.coverPhoto) === null || _folder$coverPhoto === void 0 ? void 0 : _folder$coverPhoto.width) > ((_folder$coverPhoto2 = folder.coverPhoto) === null || _folder$coverPhoto2 === void 0 ? void 0 : _folder$coverPhoto2.height)) {
          imgStyle.maxHeight = slideHeight;
        } else {
          var _folder$coverPhoto3, _folder$coverPhoto4;

          imgStyle.height = slideHeight;
          imgStyle.width = slideHeight * ((_folder$coverPhoto3 = folder.coverPhoto) === null || _folder$coverPhoto3 === void 0 ? void 0 : _folder$coverPhoto3.width) / ((_folder$coverPhoto4 = folder.coverPhoto) === null || _folder$coverPhoto4 === void 0 ? void 0 : _folder$coverPhoto4.height);
        }

        return /*#__PURE__*/_react["default"].createElement(_Elements2.StyleSlideItemBox, {
          key: folder.id,
          colour: _constants.PORTFOLIO_THEME_COLOR[colour]
        }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: "".concat(publicUrl, "/gallery/").concat(folder.id)
        }, /*#__PURE__*/_react["default"].createElement(_Elements2.StyledSlideImageMainBox, {
          height: slideHeight,
          flex: true,
          align: "center",
          pointer: true
        }, /*#__PURE__*/_react["default"].createElement("img", {
          style: imgStyle,
          alt: "cover-".concat(folder === null || folder === void 0 ? void 0 : folder.name),
          onContextMenu: function onContextMenu(e) {
            return e.preventDefault();
          },
          src: (0, _helpers.getImageByFormat)((_folder$coverPhoto5 = folder.coverPhoto) === null || _folder$coverPhoto5 === void 0 ? void 0 : _folder$coverPhoto5.images[0], webpSupported)
        })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioHeadingMedium, {
          className: "newton-folder-name",
          portfolioFontFamily: true,
          portfolioForeground1: true,
          normal: true,
          py: "md"
        }, folder === null || folder === void 0 ? void 0 : folder.name)));
      }

      return null;
    })));
  }

  return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledMobileFolderList, null, folders.map(function (folder) {
    var _folder$coverPhoto6, _folder$coverPhoto7, _folder$coverPhoto8;

    var imgStyle = {};

    if (((_folder$coverPhoto6 = folder.coverPhoto) === null || _folder$coverPhoto6 === void 0 ? void 0 : _folder$coverPhoto6.width) > ((_folder$coverPhoto7 = folder.coverPhoto) === null || _folder$coverPhoto7 === void 0 ? void 0 : _folder$coverPhoto7.height)) {
      imgStyle.width = '100%';
    } else {
      imgStyle.height = window.innerHeight - 76;
    }

    return /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      key: folder.id
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(folder.id),
      onClick: function onClick() {
        window.scrollTo(0, 0);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.StyledMobileImageBox, {
      flex: true,
      align: "center",
      justify: "center",
      pointer: true
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.Image, {
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      src: (0, _helpers.getImageByFormat)((_folder$coverPhoto8 = folder.coverPhoto) === null || _folder$coverPhoto8 === void 0 ? void 0 : _folder$coverPhoto8.images[0], webpSupported)
    })), /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
      portfolioFontFamily: true,
      portfolioForeground1: true,
      normal: true,
      style: {
        padding: '24px 0 40px'
      }
    }, folder === null || folder === void 0 ? void 0 : folder.name)));
  }));
};

NewtonFolder.defaultProps = {
  publicUrl: '',
  colour: '',
  webpSupported: false
};
NewtonFolder.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  publicUrl: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  webpSupported: _propTypes["default"].bool
};
var _default = NewtonFolder;
exports["default"] = _default;